export const ITEMS = [
{
	id:0,
	name:"site home image",
	image:"assets/images/home-image4.png"
}
];
export const PRODUCTS_IN_STALK = [
	{

	}
]
export const PRODUCTS = [
	{
		id:Math.random().toString(),
		description:"Lorem ipsum dolar set et mua",
		image:"assets/images/product-images/best-product-image1.jpeg",
		name:"P9 Bluetooth",
		action:"Add to Cart"
	   },
	   {
		id:Math.random().toString(),
		description:"Lorem ipsum dolar set et mua",
		image:"assets/images/product-images/best-product-image2.jpg",
		name:"wireless Bluetooth",
		action:"Add to Cart"
	   },
	   {
		id:Math.random().toString(),
		description:"Lorem ipsum dolar set et mua",
		image:"assets/images/product-images/best-product-image3.jpg",
		name:"Noise Cancelling Headphone",
		action:"Add to Cart"
	   },
	   {
		id:Math.random().toString(),
		description:"Lorem ipsum dolar set et mua",
		image:"assets/images/product-images/best-product-image4.png",
		name:"Extra Bass Bluetooth",
		action:"Add to Cart"
	   }
]
export const POPULAR_PRODUCTS = [
	{
		
	}
]